import { useEffect, useState } from 'react';

import styles from './stylesChartNav.module.scss';

import { ChartDeepOptions, ChartDefaultOption } from './constants/index.jsx';

const ChartNav = ({ count, selectedDeep, onChangeDeep }) => {
  const [checkedValues, setCheckedValues] = useState([ChartDefaultOption]);

  const handleChange = (value) => {
    if (!value) return;

    let values = [...checkedValues];
    if (values.find((el) => el.value === value.value)) {
      if (values.length === 1) return;
      values = values.filter((el) => el.value !== value.value);
    } else {
      values.push({
        value: value.value,
        color: value.color,
      });
    }
    const sorted = values.sort((a, b) => Number(a.value) - Number(b.value));
    setCheckedValues(sorted);
    onChangeDeep(sorted);
  };

  useEffect(() => {
    if (selectedDeep) {
      setCheckedValues(selectedDeep);
    }
  }, [selectedDeep]);

  return (
    <>
      <div className={styles.chartNav}>
        <div className={styles.chartNavList}>
          {ChartDeepOptions.map((option, index) => (
            <label
              key={option.value}
              style={option.style}
              className={`${styles.chartNavItem} ${count > 0 && index + 1 > count ? styles.chartNavItemDisabled : ''}`}
            >
              <input
                type="checkbox"
                checked={!!checkedValues.find((el) => el.value === option.value)}
                disabled={count > 0 && index + 1 > count}
                onChange={() => handleChange(option)}
              />
              <div className={styles.chartNavItemButton}></div>
              <span className={styles.chartNavItemText}>{option.value}</span>
              <span className={styles.chartNavItemShadow}>{option.value}</span>
            </label>
          ))}
        </div>
        <div className={styles.chartNavLabel}>Deep</div>
      </div>
    </>
  );
};

export default ChartNav;
